import { Button } from '@mui/material';
import { faPlus } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useContext } from 'react';

import { BacktestingContext } from '../../../../../providers/backtesting/backtesting-provider';

import './styles.scss';

// Shown in the shell when the working study has no backtests configured (e.g.
// the initial load, or after deleting the last one). Replaces the old
// StrategySelector landing page — the shell is the only content surface now,
// with the sidebar's Model backtests / New study alongside.
export const BacktestEmptyStudy = () => {
  const { activeBacktestId, addStrategy } = useContext(BacktestingContext);

  return (
    <div className="backtest-empty-study">
      <h3 className="backtest-empty-study-title">This study has no backtests yet</h3>
      <p className="backtest-empty-study-body">
        Add a backtest to configure and run it, or start from a Model backtest in the sidebar.
      </p>
      <Button
        className="backtest-empty-study-button"
        onClick={() => activeBacktestId && addStrategy(activeBacktestId)}
      >
        <FontAwesomeIcon icon={faPlus} />
        <span>Add a backtest</span>
      </Button>
    </div>
  );
};
